import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { Result } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import FeedbackForm, { FeedbackFormValues } from './Form'
import FeedbackThumbs from './Thumbs'

export interface Props {
  question?: string | React.ReactNode
  onSubmit: (submit: FeedbackRequestSubmitProps) => Promise<Result<unknown>>
}

export interface FeedbackRequestSubmitProps {
  result: boolean | undefined
  comment?: string
  commentSubmitted?: boolean
}

const FeedbackRequest = ({ question, onSubmit }: Props) => {
  const [result, setResult] = React.useState<boolean | undefined>(undefined)
  const [showForm, setShowForm] = React.useState<boolean>(false)

  const questionOnThumbsUp = async () => {
    const newResult = result === true ? undefined : true

    const response = await onSubmit({ result: newResult })

    if (response.success === false) {
      return
    }

    setResult(newResult)
    setShowForm(false)

    const message =
      newResult === true ? i18n.t('common.feedback.success') : i18n.t('common.feedback.removed')

    app.setFlash({
      type: 'correct',
      message,
    })
  }

  const questionOnThumbsDown = async () => {
    const newResult = result === false ? undefined : false
    const response = await onSubmit({ result: newResult })

    if (response.success === false) {
      return
    }

    setResult(newResult)
    setShowForm(true)

    if (newResult === undefined) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.feedback.removed'),
      })
    }
  }

  const questionOnFormSubmit = async (data: FeedbackFormValues) => {
    const response = await onSubmit({
      result: false,
      comment: data.comment,
      commentSubmitted: true,
    })

    if (response.success === false) {
      return
    }

    setShowForm(false)

    app.setFlash({
      type: 'correct',
      message: i18n.t('common.feedback.success'),
    })
  }

  const questionOnFormDismiss = async () => {
    setShowForm(false)
  }

  return (
    <Box flexDirection="column">
      <Box flexDirection="row" justifyContent="flexStart" alignItems="center" gap="s8">
        {question || (
          <Box>
            <Text.Normal>{i18n.t('common.feedback.question')}</Text.Normal>
          </Box>
        )}
        <FeedbackThumbs
          result={result}
          onThumbsUp={questionOnThumbsUp}
          onThumbsDown={questionOnThumbsDown}
        />
      </Box>
      {result === false && showForm && (
        <FeedbackForm onFormSubmit={questionOnFormSubmit} onFormDismiss={questionOnFormDismiss} />
      )}
    </Box>
  )
}

export default FeedbackRequest
